'use client';

import { api } from '@/services/api';
import { ProductProps } from '@/types/Product';
import { Flex, Skeleton } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { MdOutlineNewReleases } from 'react-icons/md';
import ProductsGrid from '../../ProductsGrid';

const NewProductsList = () => {
  const [products, setProducts] = useState<ProductProps[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await api.get(
          '/products/list/categories?sort=newest&page=1&limit=15',
        );
        setProducts(response.data.items);
      } catch {
        // Falha silenciosa — sem novidades, a secção simplesmente não aparece.
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <Flex
        bg={{ base: '#FFFFFF', _dark: '#0A1B2B' }}
        px={{ base: '16px', md: '24px' }}
        py="24px"
        flexDir="column"
        mb="20px"
        w="100%"
        borderRadius="20px"
        border="1.5px solid"
        borderColor={{ base: 'rgba(0,176,202,0.1)', _dark: 'rgba(0,176,202,0.07)' }}
        gap="16px"
      >
        <Skeleton h="32px" w="200px" borderRadius="8px" />
        <Flex gap="16px" overflow="hidden">
          {[0, 1, 2, 3].map((i) => (
            <Skeleton key={i} w="260px" h="380px" borderRadius="20px" flexShrink={0} />
          ))}
        </Flex>
      </Flex>
    );
  }

  if (products.length === 0) return null;

  return (
    <ProductsGrid
      IconReact={MdOutlineNewReleases}
      title="Novidades"
      products={products}
      viewAllHref="/novidades"
    />
  );
};

export default NewProductsList;
